import { render, staticRenderFns } from "./tradeLeadNew.vue?vue&type=template&id=37196bf7&scoped=true&"
import script from "./tradeLeadNew.vue?vue&type=script&lang=js&"
export * from "./tradeLeadNew.vue?vue&type=script&lang=js&"
import style0 from "./tradeLeadNew.vue?vue&type=style&index=0&id=37196bf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37196bf7",
  null
  
)

export default component.exports